import { Box, Typography } from "@mui/material";
import React from "react";
import theme from "../../utils/theme";

import headerIcon from '../../assets/images/logo2.png'

const SuperMobile = ({ screenWidth }) => {
    return (
        <Box sx={{
            width: screenWidth
        }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center'
            }}>
                <img
                    src={headerIcon}
                    alt='Header Icon'
                    loading="lazy"
                    style={{
                        width: theme.palette.logoSize.larger
                    }}
                />
                <Box width='10px' />
                <Box sx={{
                    display: 'flex',
                }}>
                    <Typography sx={{
                        fontSize: theme.palette.logoFontsize.large,
                        fontWeight: 'bold',
                        color: theme.palette.primary.main
                    }}>SUPER MOBILE</Typography>
                </Box>
            </Box>
            <Box height='20px'/>
        </Box>
    )
}

export default SuperMobile